<div id="price-details-modal" class="modal-md price-details">
  <div class="modal-header state">
    <h1
      class="modal-title text-truncate full-width text-align-center"
      id="modal-label"
    >
      {{ order ? 'Order' : 'Item' }} Summary
    </h1>
    <button
      id="price-details-modal-close-btn"
      type="button"
      (click)="close()"
      class="close btn btn-icon"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="price-details--container">
      <div>
        <span class="label">Subtotal</span>
        <span class="price">{{ subTotal | currency }}</span>
      </div>
      <div>
        <span class="label">Shipping</span>
        <span class="price">{{ shipping | currency }}</span>
      </div>
      <div>
        <span class="label">Taxes</span>
        <span class="price">{{ taxes | currency }}</span>
      </div>

      @if (budget > 0 || discount > 0) {
        <hr class="mb-0" />
      }

      @if (discount > 0) {
        <div>
          <span class="label">Discount</span>
          <span class="price green">-{{ discount | currency }}</span>
        </div>
      }
      @if (budget > 0) {
        <div>
          <a
            href="#"
            class="link link-underline font-5 fw-normal"
            (click)="onBudgetDetailsClick()"
            >Budget Applied&nbsp;<i class="fas fa-exclamation-circle"></i
          ></a>
          <span class="price green">-{{ budget | currency }}</span>
        </div>
      }

      <hr />

      <div>
        <span class="label total">Total Cost</span>
        <span class="price">{{ totalCost | currency }}</span>
      </div>
    </div>
  </div>
</div>
